export default class Segment {
	constructor({ elements }) {
		elements.forEach((el) => {
			const { trackingEventName, properties } = el.dataset;
			try {
				const parsedData = JSON.parse(properties);
				el.addEventListener('click', () => Segment.sendData(trackingEventName, parsedData));
			} catch (error) {
				console.error(error);
			}
		});
	}

	static sendData(trackingEventName, parsedData) {
		const properties = parsedData;
		if ('filters' in properties) {
			properties.filters = Segment.getFilters();
		}
		if ('primary_skills' in properties) {
			properties.primary_skills = this.createArray(properties.primary_skills);
		}
		if ('secondary_skills' in properties) {
			properties.secondary_skills = this.createArray(properties.secondary_skills);
		}
		if ('template_categories' in properties) {
			properties.template_categories = this.createArray(properties.template_categories);
		}
		if ('template_subcategories' in properties) {
			properties.template_subcategories = this.createArray(properties.template_subcategories);
		}
		window?.analytics?.track(trackingEventName, properties);
	}

	static createArray(stringList) {
		return stringList.split(', ');
	}

	static getFilters() {
		const params = new URLSearchParams(window.location.search);
		const filters = [];
		if ([...params].length > 0) {
			params.forEach((value, key) => {
				const values = value.split(',').map((item) => item.trim());
				const filter = {};
				filter[`${key}`] = values;
				filters.push(filter);
			});
		}
		return filters;
	}
}
